import { FC } from "react";

import { css, cx } from "@/domains/emotion";
import { MdsDropdownDetailItem } from "@/design-system/components/dropdown";
import { useTheme } from "@emotion/react";

export interface MdsDropdownDetailItemComponentProps {
  className?: string;
  item: MdsDropdownDetailItem;
}

const wrapperStyles = css({
  display: "flex",
  flexDirection: "column",
  flexWrap: "nowrap",
  justifyContent: "center",
});

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const MdsDropdownDetailItemComponent: FC<MdsDropdownDetailItemComponentProps> = ({
  className,
  item,
}) => {
  const theme = useTheme();
  const detailStyles = css({
    fontSize: theme.fontSizes["text-xs"],
    lineHeight: theme.lineHeights["text-xs"],
    fontWeight: theme.fontWeights.semiBold,
    color: theme.colors.text.secondary,
    paddingBlock: theme.spacing["2"],
    paddingInline: theme.spacing["5"],
  });
  const styles = cx(className, detailStyles, item.className);
  return (
    <div className={wrapperStyles}>
      <div className={styles}>{item.text}</div>
    </div>
  );
};
